import React from 'react';

import styled from 'styled-components';

import { getSortFields } from 'components/form-multi/utils';

import { URL_SOCIAL_LINKS } from 'constants/UrlConstants';

import promoColors from 'theme/promoColors';

const SocialLinksContainer = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 32px;

    a {
        &:hover {
            opacity: 0.4;
        }

        &:focus-visible {
            border-radius: 50%;
            opacity: 0.4;
            outline: 1px dashed ${promoColors.gray80};
        }

        & + a {
            margin-left: 24px;
        }
    }
`;

function SocialLinks(props) {
    const { links } = props;

    const getLinks = (arrLinks) => {
        return getSortFields(arrLinks).map(({ isBlank, name, url }) => {
            return (
                <a key={name.replace(/\s/g, '')} rel="noreferrer noopener nofollower" target={isBlank ? '_blank' : '_self'} href={url} aria-label={name}>
                    <img src={`${URL_SOCIAL_LINKS}/${name}.svg`} alt={name} width="32" height="32" loading="lazy" />
                </a>
            );
        });
    };

    return <SocialLinksContainer>{links ? getLinks(links) : null}</SocialLinksContainer>;
}
export default SocialLinks;
